/**
 * @file The document store singleton on `parameters/analytics`, the
 * service-read analytics parameters. Consumers: the Settings → Analytics
 * sections, which read it and save through the `saveAnalyticsConfig`
 * callable. Never write this document through the store's methods: the rules
 * deny every client write, and they would add `modifiedAt`, a key the parser
 * refuses.
 */
import { ANALYTICS_PARAMETERS_PATH, type AnalyticsParameters } from '#types';
import { createDocumentStore } from '@/store';

export const analyticsParametersStore = createDocumentStore<
  Partial<AnalyticsParameters>
>(ANALYTICS_PARAMETERS_PATH);
